import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Calendar, Trash } from 'react-bootstrap-icons';
import './Node.css';

const WaitForDateNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define color scheme
  const colors = {
    container: 'custom-node node-rounded-lg node-border-red',
    header: 'node-header node-bg-red-gradient node-border-red-bottom',
    text: 'node-text-red',
    handle: 'node-handle-small node-handle-red'
  };

  const edgeLabels = [];
  
  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'No date set';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div 
      className={`${colors.container} node-hover-lift node-wait-date`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        if (data.onNodeClick) {
          data.onNodeClick(id);
        }
      }}
    >
      {/* Delete button - Added opacity and transition */}
      <div 
        className={`delete-btn delete-btn.top-center ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      {/* Header section */}
      <div className={colors.header}>
        <div className="node-header-content">
          <Calendar className='node-icon' style={{ color: '#d6201c' }}/>
          <div className="node-flex node-flex-col">
            <span className={`node-title ${colors.text}`}>Wait for Date</span>
            <span className="node-text-sm node-text-gray-600">
              {formatDate(data.selectedDate)}
            </span>
          </div>
        </div>
      </div>

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className={colors.handle}
      />
      
      {/* Output handles */}
      <div className="node-output-handles">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <Handle
            key={`output-${index}`}        
            type="source"
            position={Position.Right}
            id={`output-${index}`}
            className={colors.handle}
            style={{ 
              top: `${((index + 1) * 100) / (outputEdges + 1)}%`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default WaitForDateNode; 
